/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Cancel_Force_LabelInputs */

const vi_carrier_cancel_force_label = /** @type {(inputs: Carrier_Cancel_Force_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tôi đã kiểm tra trên hệ thống hãng: không có vận đơn cho đơn này`)
};

/**

* @param {Carrier_Cancel_Force_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_cancel_force_label = /** @type {((inputs?: Carrier_Cancel_Force_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Cancel_Force_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_cancel_force_label(inputs)
});